// libs
import React, { memo } from 'react';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { TABLE_COLUMNS } from '../constants';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { KeywordMatchType } from '@local/typedefs/dist/protos/campaign/Criteria';
// widgets
import EditButton from '@/widgets/EditButton';
import Table from '@/widgets/Table';
import Line from '@/widgets/Line';
// styles
import styles from '../ReviewCampaign.module.scss';
import { formatNumberIntl, prefixWithRupee } from '@/helpers/utils';
const Keywords = ({ keywords, setActiveStep }) => {
    const handleEditClick = () => {
        // Index 3 is for keywords screen
        setActiveStep(3);
    };
    const renderRow = (row, index) => {
        return (React.createElement(React.Fragment, null,
            React.createElement("ul", { className: cx(styles.keywordsTableRow) },
                React.createElement("li", { style: { width: TABLE_COLUMNS[0].width }, className: styles.keywordsTableCellKeyword },
                    React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Med_Emphasis }, row.keywordText)),
                React.createElement("li", { style: { width: TABLE_COLUMNS[1].width }, className: styles.keywordsTableCellMatchType },
                    React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, row.matchType ===
                        KeywordMatchType.KEYWORD_MATCH_TYPE_BROAD
                        ? 'Broad'
                        : 'Exact')),
                React.createElement("li", { style: { width: TABLE_COLUMNS[2].width }, className: styles.keywordsTableCellBid },
                    React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, prefixWithRupee(formatNumberIntl({ value: row.bid }))))),
            React.createElement(Line, { className: styles.keywordsTableLine })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.containerHeaderSub },
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, "Keywords"),
            React.createElement(EditButton, { label: "Edit", onClick: handleEditClick })),
        React.createElement("div", { className: styles.keywordsTableWrapper },
            React.createElement(Table, { data: keywords, columns: TABLE_COLUMNS, renderRow: renderRow, onSort: () => void 0, classNames: { container: styles.keywordsTable } }))));
};
export default memo(Keywords);
